import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { SecondaryButton, TransparentBgButton } from '../Shared/Button'

export default function CancelEditModalContent({ onCancel, onConfirm }) {
  const { t } = useTranslation()

  return (
    <div className="yes-no-prompt">
      <div className="yes-no-prompt_content">
        <h1>{t('EventEditor.cancelEdit.cta')}</h1>
        <p>{t('EventEditor.cancelEdit.body')}</p>
      </div>
      <div className="yes-no-prompt_footer">
        <TransparentBgButton text={t('EventEditor.cancelEdit.btnCancel')} onClick={onCancel} color="navy" />
        <SecondaryButton
          className="bt"
          text={t('EventEditor.cancelEdit.btnConfirm')}
          fullWidth={false}
          onClick={onConfirm}
        />
      </div>
    </div>
  )
}

CancelEditModalContent.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
}
